import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useOrderNotifications } from './useOrderNotifications';

export const useRealtimeOrderNotifications = () => {
  const { sendVendorNotification, sendOrderNotification, sendDriverNotification } = useOrderNotifications();

  useEffect(() => {
    // Listen for new orders to notify vendors
    const newOrdersChannel = supabase
      .channel('new-orders-notifications')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'orders',
        },
        async (payload) => {
          console.log('New order created:', payload);
          
          if (payload.new) {
            const order = payload.new as any;
            
            // Send notification to vendor
            await sendVendorNotification(order.restaurant_id, {
              orderId: order.id,
              customerName: order.customer_name || 'Customer',
              totalAmount: order.total_amount
            });
          }
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'orders',
        },
        async (payload) => {
          console.log('Order updated:', payload);
          
          if (payload.new && payload.old) {
            const newOrder = payload.new as any;
            const oldOrder = payload.old as any;
            
            // Only send notifications if status actually changed
            if (newOrder.status !== oldOrder.status) {
              console.log(`Order status changed from ${oldOrder.status} to ${newOrder.status}`);
              
              // Send customer notification for status updates
              await sendOrderNotification(
                newOrder.id,
                newOrder.status,
                newOrder.customer_name,
                'Restaurant'
              );
              
              // Send driver notification for new assignments
              if (newOrder.driver_id && !oldOrder.driver_id && newOrder.delivery_type === 'delivery') {
                // Get restaurant name for driver notification
                const { data: restaurant } = await supabase
                  .from('restaurants')
                  .select('name')
                  .eq('id', newOrder.restaurant_id)
                  .single();
                
                await sendDriverNotification(newOrder.driver_id, {
                  orderId: newOrder.id,
                  restaurantName: restaurant?.name || 'Restaurant',
                  customerName: newOrder.customer_name || 'Customer',
                  deliveryAddress: newOrder.delivery_address || 'Unknown'
                });
              }
            }
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(newOrdersChannel);
    };
  }, [sendVendorNotification, sendOrderNotification, sendDriverNotification]);

  return {
    // Can add methods here if needed in the future
  };
};